/* ST 2026-10-15 (Wrike 4584521801): (i) buttons of the bundle option list (snippets/st-bundle-options.liquid).
   Opening/closing, overlay, scroll lock, focus trap, Escape and swipe are the theme's <drawer-element>; focus on the X
   after opening is assets/st-pdp-info.js. The theme binds a drawer to its aria-controls buttons once on load, but
   theme.js re-renders the variant picker (and these buttons) on every variant change, so the buttons use
   data-st-bopt-open and are handled here by delegation. After closing, focus goes back to the current (i) button.
   Rollback: switch the variant_picker setting st_bundle_list off. */
(function () {
  if (window.stBundleOptionsReady) return;
  window.stBundleOptionsReady = true;

  document.addEventListener("click", function (event) {
    var button =
      event.target && event.target.closest
        ? event.target.closest("[data-st-bopt-open]")
        : null;
    if (!button) return;
    var panel = document.getElementById(
      button.getAttribute("data-st-bopt-open"),
    );
    if (!panel || typeof panel.show !== "function") return;
    event.preventDefault();
    panel.show(button);
  });

  // Round 2 (16.10., Ali): Neu / Refurbished selector above the list (snippets/st-refurb-condition.liquid, proxy mode).
  // Its radios carry no option data; a change is stopped before the theme's <variant-picker> sees it and forwarded to the
  // option radio of the list, so the variant flow (price, gallery, URL, cart variant) is the theme's. "Neu" goes back to
  // the last bundle chosen on this page (sessionStorage per list), else to the base variant (data-st-cond-target).
  // Capture on document: assets/st-refurb-condition.js listens there too (info box animation) and still runs.
  function storeKey(input) {
    return "stBoptNeu:" + (input.name || "");
  }

  document.addEventListener(
    "change",
    function (event) {
      var input = event.target;
      if (!input || !input.matches) return;

      if (input.matches(".st-bopt__item input[type=radio]")) {
        if (input.closest(".st-bopt__item[hidden]")) return;
        try {
          sessionStorage.setItem(
            storeKey(input),
            input.getAttribute("data-option-value-id"),
          );
        } catch (e) {
          /* storage blocked */
        }
        return;
      }

      if (!input.hasAttribute("data-st-cond-target")) return;
      event.stopPropagation();
      var target = document.getElementById(
        input.getAttribute("data-st-cond-target"),
      );
      if (!target) return;
      if (input.hasAttribute("data-st-cond-neu")) {
        var last = null;
        try {
          last = sessionStorage.getItem(storeKey(target));
        } catch (e) {
          /* storage blocked */
        }
        var list = target.closest(".st-bopt");
        var remembered =
          last && list
            ? list.querySelector(
                '.st-bopt__item:not([hidden]) input[data-option-value-id="' +
                  last +
                  '"]:not(:disabled)',
              )
            : null;
        if (remembered) target = remembered;
      }
      if (!target.checked) target.click();
    },
    true,
  );

  document.addEventListener("drawer:afterHide", function (event) {
    var panel = event.target;
    if (!panel.classList || !panel.classList.contains("st-bopt-panel")) return;
    setTimeout(function () {
      if (document.activeElement && document.activeElement !== document.body)
        return;
      var button = document.querySelector(
        '[data-st-bopt-open="' + panel.id + '"]',
      );
      if (button) button.focus({ preventScroll: true });
    }, 60);
  });
})();
